import React from 'react'
import './Footer.css'
import '../../Global.css'
function Footer() {
  return (
    <div className="footer">
        <p>&copy; Kodi Roshan, 2026</p>
    </div>
  )
}

export default Footer
